import { dotToCommaTransform } from "@/lib/formatters/NumericTextFieldInputCleaner";
import {
  createColumnConfig,
  StandardTableConfigWithNoGroups,
} from "@stenajs-webui/grid";

export interface ThreeYearsPricePerMeterTableRow {
  routePairCode: string;
  year: number;
  pricePerMeter: number | null;
  pricePerMeterMinus1Year: number | null;
  pricePerMeterMinus2Year: number | null;
}

export type ThreeYearsPricePerMeterTableColumn = keyof Omit<
  ThreeYearsPricePerMeterTableRow,
  "year"
>;

const transformToPricePerMeterWithCurrency = (
  pricePerMeter: number | null,
  currencyCode: string
) => {
  return pricePerMeter != null
    ? `${dotToCommaTransform(String(pricePerMeter ?? ""))} ${currencyCode}`
    : "";
};

export const threeYearsPricePerMeterTableConfig = (
  year: number,
  currencyCode: string
) => {
  const threeYearsPricePerMeterTableConfig: StandardTableConfigWithNoGroups<
    ThreeYearsPricePerMeterTableRow,
    ThreeYearsPricePerMeterTableColumn
  > = {
    keyResolver: (item) => `${item.routePairCode}-${item.year}`,
    disableSorting: true,
    columns: {
      routePairCode: createColumnConfig((item) => item.routePairCode, {
        columnLabel: "",
      }),
      pricePerMeter: createColumnConfig(
        (item) =>
          transformToPricePerMeterWithCurrency(
            item.pricePerMeter,
            currencyCode
          ),
        {
          columnLabel: `${year}`,
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
          borderLeft: true,
        }
      ),
      pricePerMeterMinus1Year: createColumnConfig(
        (item) =>
          transformToPricePerMeterWithCurrency(
            item.pricePerMeterMinus1Year,
            currencyCode
          ),
        {
          columnLabel: `${year - 1}`,
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
          borderLeft: true,
        }
      ),
      pricePerMeterMinus2Year: createColumnConfig(
        (item) =>
          transformToPricePerMeterWithCurrency(
            item.pricePerMeterMinus2Year,
            currencyCode
          ),
        {
          columnLabel: `${year - 2}`,
          justifyContentHeader: "flex-end",
          justifyContentCell: "flex-end",
          borderLeft: true,
        }
      ),
    },
    columnOrder: [
      "routePairCode",
      "pricePerMeterMinus2Year",
      "pricePerMeterMinus1Year",
      "pricePerMeter",
    ],
  };
  return threeYearsPricePerMeterTableConfig;
};
